import { useState } from 'react'
import { AnimatePresence, motion, Variants } from 'framer-motion'

import {
  ConfirmButton,
  Dot,
  Label,
  LabelText,
  SliderContainer,
  SliderInput,
  StaticLabel,
} from './styled'

const labelVariants = (delay: number, value: number): Variants => ({
  initial: {
    translateX: `${value}%`,
    height: 0,
    opacity: 0,
  },
  enter: {
    opacity: 1,
    height: 60,
    transition: { delay, delayChildren: 1.5, staggerChildren: 0.2 },
  },
})

const innerVariants: Variants = {
  initial: {
    opacity: 0,
    translateX: -10,
  },
  enter: {
    opacity: 1,
    translateX: 0,
  },
}

export const Slider = ({
  onChange,
  selectedValue,
}: {
  onChange: (value: number) => void
  selectedValue?: string
}) => {
  const [value, setValue] = useState(50)

  return (
    <SliderContainer layout>
      <AnimatePresence mode="popLayout">
        {selectedValue ? (
          <motion.div
            key="label1"
            layout
            style={{
              position: 'absolute',
              width: '104%',
              bottom: '100%',
              left: '-2%',
            }}
          >
            <StaticLabel
              $align={value > 50 ? 'right' : 'left'}
              $verticalAlign="top"
              $accent="primary"
              variants={labelVariants(0.4, value)}
              initial="initial"
              animate="enter"
            >
              <LabelText>
                <motion.div variants={innerVariants}>
                  <strong>Ваш ответ:</strong> <br />
                </motion.div>
                <motion.div variants={innerVariants}>{value}%</motion.div>
              </LabelText>
            </StaticLabel>
          </motion.div>
        ) : (
          <motion.div
            key="label"
            layout
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <Label
              animate={{
                translateX: `${value}%`,
                transition: { type: 'tween', duration: 0 },
              }}
            >
              <LabelText>{value}%</LabelText>
            </Label>
          </motion.div>
        )}

        <motion.p key="slider" layout>
          <SliderInput
            min="0"
            max="100"
            defaultValue={value}
            disabled={!!selectedValue}
            onChange={(evt) => setValue(evt.currentTarget.valueAsNumber)}
          />
        </motion.p>

        {selectedValue && (
          <>
            <Dot
              key="dot"
              initial={{
                translateX: `56%`,
                scale: 0,
              }}
              animate={{
                translateX: `56%`,
                scale: 1,
                transition: { delay: 1 },
              }}
            />
            <motion.div
              key="label2"
              layout
              style={{ position: 'absolute', width: '100%', top: '100%' }}
            >
              <StaticLabel
                $align="right"
                $verticalAlign="bottom"
                $accent="success"
                variants={labelVariants(2, 56)}
                initial="initial"
                animate="enter"
              >
                <LabelText>
                  <motion.div variants={innerVariants}>
                    <strong>Правильный ответ:</strong> <br />
                  </motion.div>
                  <motion.div variants={innerVariants}>56%</motion.div>
                </LabelText>
              </StaticLabel>
            </motion.div>
          </>
        )}

        {!selectedValue && (
          <motion.p
            key="confirm"
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            layout
          >
            <ConfirmButton
              disabled={!!selectedValue}
              onClick={() => onChange(value)}
            >
              Подтвердить
            </ConfirmButton>
          </motion.p>
        )}
      </AnimatePresence>
    </SliderContainer>
  )
}
